export default __webpack_public_path__ + "static/media/foxHome.0f09f160.jpg";